'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdFormatColorFill = function MdFormatColorFill(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm0 33.4h40v6.6h-40v-6.6z m31.6-14.3q3.4 3.7 3.4 5.9 0 1.3-1 2.3t-2.4 1.1-2.3-1.1-0.9-2.3q0-0.9 0.8-2.4t1.6-2.4z m-22.9-2.5h16l-8.1-7.9z m18.9-1.7q0.8 0.8 0.8 1.8t-0.8 1.7l-9.2 9.2q-0.7 0.8-1.8 0.8-0.9 0-1.7-0.8l-9.2-9.2q-0.8-0.7-0.8-1.7t0.8-1.8l8.6-8.6-4-4 2.4-2.3z' })
        )
    );
};

exports.default = MdFormatColorFill;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/format-color-fill.js
// module id = 768
// module chunks = 0